<form nz-form [formGroup]="input.formGroup" nzLayout="horizontal" class="p-4" (keydown.enter)="$event.preventDefault()">
	<div class="modal-body">
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true" nzFor="orderIndex">
				<app-invalid-form-indicator [form]="input.formGroup" field="orderIndex" class="me-3"></app-invalid-form-indicator>
				Order Index
			</nz-form-label>
			<nz-form-control [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required',minLength: 'Must be at least 1 character',maxLength: 'Cannot exceed 100 characters',pattern: 'Must start with a letter/underscore and contain only letters, digits, or underscores'}}">
				<input nz-input id="orderIndex" formControlName="orderIndex" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="6" nzFor="actionType">
				<app-invalid-form-indicator [form]="input.formGroup" field="actionType" class="me-3"></app-invalid-form-indicator>
				Type
			</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select formControlName="actionType" id="actionType">
					<nz-option [nzValue]="undefined" [nzLabel]="'None'"></nz-option>
					<ng-container *ngFor="let item of actionTypes">
						<nz-option [nzValue]="item" [nzLabel]="item"></nz-option>
					</ng-container>
				</nz-select>
			</nz-form-control>
		</nz-form-item>


		<ng-container *ngIf="input._actionType == 'Movement'">
			<nz-form-item>
				<nz-form-label [nzSpan]="6" nzFor="movementWorkflowStepStatusId">
					<app-invalid-form-indicator [form]="input.formGroup" field="movementWorkflowStepStatusId" class="me-3"></app-invalid-form-indicator>
					Move to:
				</nz-form-label>
				<nz-form-control [nzSpan]="14">
					<nz-select formControlName="movementWorkflowStepStatusId" id="movementWorkflowStepStatusId">
						<ng-container *ngFor="let item of availableMovements">
							<nz-option [nzValue]="item.status.id" [nzLabel]="item.step.label + ': ' + item.status.label"></nz-option>
						</ng-container>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
		</ng-container>
		<ng-container *ngIf="input._actionType == 'AdditionalComment'">
			<nz-form-item>
				<nz-form-control [nzOffset]="6" [nzSpan]="14" [nzAutoTips]="{en: {required: 'Required'}}">
					<div class="flex flex-col gap-2">
						<label nz-checkbox formControlName="additionalCommentRequired">
							<app-invalid-form-indicator [form]="input.formGroup" field="additionalCommentRequired" class="me-3"></app-invalid-form-indicator>
							Required
						</label>
					</div>
				</nz-form-control>
			</nz-form-item>
		</ng-container>
		<ng-container *ngIf="input._actionType == 'RequiredCommunication' || input._actionType == 'AdditionalCommunication'">
			<nz-card nzTitle="Configure Email" class="compose-email-card">
					<!-- From -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="input.formGroup" field="name" class="me-3"></app-invalid-form-indicator>
							Name
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="name" placeholder="Communication Name" />
						</nz-form-control>
					</nz-form-item>
					<!-- From -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="input.formGroup" field="emailFrom" class="me-3"></app-invalid-form-indicator>
							From
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailFrom" placeholder="your@email.com" />
						</nz-form-control>
					</nz-form-item>

					<!-- To -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							<app-invalid-form-indicator [form]="input.formGroup" field="emailTo" class="me-3"></app-invalid-form-indicator>
							To
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailTo" placeholder="Recipient email(s)" />
						</nz-form-control>
					</nz-form-item>

					<!-- Cc -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							<app-invalid-form-indicator [form]="input.formGroup" field="emailCc" class="me-3"></app-invalid-form-indicator>
							CC
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailCc" placeholder="CC email(s)" />
						</nz-form-control>
					</nz-form-item>

					<!-- Bcc -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							<app-invalid-form-indicator [form]="input.formGroup" field="emailBcc" class="me-3"></app-invalid-form-indicator>
							BCC
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailBcc" placeholder="BCC email(s)" />
						</nz-form-control>
					</nz-form-item>

					<!-- Subject -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="input.formGroup" field="emailSubject" class="me-3"></app-invalid-form-indicator>
							Subject
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailSubject" placeholder="Email subject" />
						</nz-form-control>
					</nz-form-item>

					<!-- Body -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="input.formGroup" field="emailBody" class="me-3"></app-invalid-form-indicator>
							Body
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<app-email-body-editor *ngIf="emailPlaceholders" [placeholders]="emailPlaceholders" formControlName="emailBody"></app-email-body-editor>
							<span *ngIf="!emailPlaceholders">Loading...</span>
						</nz-form-control>
					</nz-form-item>

					<!-- Attachments -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							Attachments
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<nz-upload [nzMultiple]="true" [nzFileList]="attachments" [nzCustomRequest]="customUpload">
								<button nz-button>
									<i nz-icon nzType="upload"></i>
									Select File
								</button>
							</nz-upload>
						</nz-form-control>
					</nz-form-item>
			</nz-card>
		</ng-container>
	</div>
	<div class="modal-footer" style="text-align: right;">
		<nz-form-item>
			<nz-form-control>
				<button nz-button nzType="primary" [disabled]="!input.formGroup.valid" (click)="doClose()">Close</button>
				<button class="me-1" nz-button nzDanger="" nzType="primary" (click)="doDelete()">Delete</button>
			</nz-form-control>
		</nz-form-item>
	</div>
</form>
